import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";

class AppUsageReports extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>App Usage Reports</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/app-usage/overview'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>
                                    App Usage Overview
                                </h3>
                                <p className='card-text'>
                                    View app usage totals by page.
                                </p>
                            </div>
                        </Link>
                    </div>

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/app-usage/list'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>App Usage List</h3>
                                <p className='card-text'>
                                    View recent app usage records.
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default AppUsageReports;
